<template>

  <div class="pattern-closer">
    <div v-if="!hideSelect">
      <section class="selected-pattern" v-if="getSelected.id">
        <strong>{{$t('pattern.selected')}}</strong>

        <span>{{ $t('pattern.selection', {title: getSelected.title, designer: getSelected.owner} )}}</span>
        &nbsp; <a class="cursor-pointer" @click="unsetPreview">{{ $t('pattern.un-select')}}</a>

      </section>
      <button @click="closeModal" :disabled="isBackgroundProcessing">
        <span v-if="isBackgroundProcessing">
                  <svg style="height: 16px;" class="animate animate-spin text-gray-400 mx-auto"
                       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="" cx="12" cy="12" r="10" stroke="currentColor"
                    stroke-width="0"></circle>
            <path class="" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>

        </span>
        <span v-else-if="getSelected.id">  {{ $t('pattern.popup.confirm') }}  </span>
        <span v-else>  {{ $t('pattern.popup.close') }}  </span>
      </button>
    </div>
    <div v-else-if="isPopUpmode">
      <button @click="closeModal">
        <span>{{ $t('pattern.popup.close') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'closer',
  computed: {
    getSelected() {
      return this.$store.state.selected;
    },
    isPopUpmode() {
      return (this.$parent.$props.mode.toLowerCase() === "pop-up");
    },
    hideSelect() {
      return (this.$parent.$props.hideSelect) ? true : false;
    },
    isBackgroundProcessing() {
      return (this.$store.state.externalProcessBusy);
    }

  },
  methods: {
    closeModal() {
      this.$emit('hidepreview');
    },
    unsetPreview() {
      this.$emit('unsetpreview')
    }
  }
}

</script>

<style>

.pattern-closer {
  @apply mt-auto
}

.pattern-closer .selected-pattern {
  @apply text-gray-500  text-sm leading-tight;

}
.pattern-closer .selected-pattern {

& strong {
  @apply block text-gray-600;
  }
& a{
  @apply underline text-gray-500 hover:text-gray-800
      }
}

.pattern-closer button {
  @apply outline-none w-full leading-none mt-4 text-base  rounded shadow mr-2.5 px-3 py-2.5 rounded text-white bg-primary;
}
.pattern-closer button[disabled]{
  @apply bg-gray-100 text-gray-400;
}

</style>